const PopoverPlugin = {
    init: ($) => {
        if ($.fn.popover) {
            $('[data-toggle="popover"]').popover();
        }
    },
};

export default PopoverPlugin;
